<!--
  Базовый select-блок ЭДО-форм.
  Единая обёртка для label, slot-селектора и ошибки выбора.
-->
<template>
  <div class="form-group">
    <div class="form-group__header">
      <base-label :required="required" :filled="filled">{{ label }}</base-label>
      <slot name="action" />
    </div>
    <slot />
    <span v-if="invalid" class="error-message">Выберите значение</span>
  </div>
</template>

<script>
export default {
  name: "EdoSelectField",

  props: {
    label: { type: String, required: true },
    required: { type: Boolean, default: false },
    invalid: { type: Boolean, default: false },
    filled: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.form-group__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
}

.form-group :deep(.label) {
  min-height: 20px;
  margin-bottom: 0;
  line-height: 20px;
  white-space: nowrap;
}

.form-group__header :slotted(.base-action-link) {
  flex: 0 0 auto;
}

.form-group :deep(.custom-select),
.form-group :deep(.select-trigger),
.form-group :deep(.input-wrapper),
.form-group :deep(.input) {
  min-width: 0;
  width: 100%;
}

.error-message {
  color: var(--color-red, #e53e3e);
  font-size: 13px;
}
</style>
